import React from 'react';
import Section from '@components/Section';
import Contact from '@models/Contact';
import analytics from '@support/analytics';

function handleClick(contact: Contact) {
  analytics.track('Contact Social Tapped', { contactId: contact.objectID });
}

export default function Websites({ contact, underline = true }) {
  if (!contact.websites || contact.websites.length === 0) {
    return null;
  }

  const validWebsites = contact.websites
    .filter(({ url }) => !!url)
    .map((item) => ({
      ...item,
      href: item.url.includes('http') ? item.url : `http://${item.url}`,
    }));

  return (
    validWebsites.length > 0 && (
      <Section>
        <Section.Title underline={underline}>Websites</Section.Title>
        {validWebsites.map((item, i) => (
          <div key={i}>
            <a onClick={handleClick.bind(null, contact)} href={item.href} target="_blank">
              {item.url.trim()}
            </a>
          </div>
        ))}
      </Section>
    )
  );
}
